import React, { useContext, useEffect, useState } from "react";
import { LexiquePatterns } from "./State";
import LexiconTable from "./LexiconTable";
import ProjectSemanticFilter from "./SemanticFilter";
import { ProjectFilterContext } from "../ProjectFilterContext";

export default function ProjectSemanticSearch(props: any) {
  const projectFilter = useContext(ProjectFilterContext);
  const [searchParams, setSearchParams] = useState({
    posPatterns: LexiquePatterns,
    term: "",
    minMaxOccurrence: [1, 1000000] as [number, number],
    enableParsing: false,
    semanticSearch: true,
    projectFilter: projectFilter.conditions
  });
  useEffect(
    () => {
      setSearchParams(s => ({
        ...s, projectFilter: projectFilter.conditions
      }));
    }
  , [projectFilter.conditions]);
  return (
    <>
      <div className="relative overflow-x-auto">
        <ProjectSemanticFilter
          onSearch={(term: string) => {
            setSearchParams({
              posPatterns: [],
              term,
              minMaxOccurrence: [1, 1000000],
              enableParsing: false,
              semanticSearch: true,
              projectFilter: projectFilter.conditions
            });
          }}
        />
        {searchParams.term != "" && (
          <LexiconTable searchParams={searchParams} />
        )}
        {searchParams.term == "" && (
          <div className="text-center text-gray-400 mt-10">
            Recherchez un terme pour afficher les résultats
          </div>
        )}
      </div>
    </>
  );
}
